import { isNull } from 'utils/tsHelpers';
import { validateRelativeDate as hasRelativeDateError } from 'utils/validateDate';
import { isEmptyDate } from './isEmptyDate';
import { convertToParsedDate } from './convertToParsedDate';

// comes in as epoc time, updates to actual date
export const getDatePickerDate = (date: string | null): string | null => {
  if (isNull(date) || isEmptyDate(date)) return convertToParsedDate();
  if (!hasRelativeDateError(date)) return date.toString();
  return convertToParsedDate(date);
};
